import * as appBridge from './appBridge';

// 返回userInfo数据
function getUserInfo() {
  return new Promise((resolve, reject) => {
    let userInfo = sessionStorage.getItem('userInfo');
    try {
      userInfo = JSON.parse(userInfo);
    } catch (error) {}
    if (userInfo && userInfo.uid) {
      resolve(userInfo);
    } else {
      return appBridge.getUserInfo().then((res) => {
        sessionStorage.setItem('userInfo', res);
        res = JSON.parse(res);
        resolve(res);
      });
    }
  }).catch((err) => {
    console.log(err);
    return {};
  });
}

let reportList = [];

// 统计上报代码是异步加载的，但是上报事件可能已经触发。需要先存储上报事件，等到已经挂载后再进行上报
function timingCheck(count = 0) {
  // 检测超时时间6s
  if (count > 60) {
    return;
  }
  let timer = setTimeout(() => {
    if (window.TDAPP) {
      var reportObj = reportList.shift();
      while (reportObj) {
        let { eventId, label, data } = reportObj;
        if (userInfo.uid) {
          data = {
            ...data,
            user_id: userInfo.uid,
            device_id: userInfo.device_id
          };
        }
        window.TDAPP.onEvent(eventId, label, data);
        console.log('report：\n', eventId, label, data);
        reportObj = reportList.shift();
      }
    } else {
      clearTimeout(timer);
      timer = null;
      timingCheck(count++);
    }
  }, 100);
}

/**
 * 统计上报  http://doc.talkingdata.com/posts/36
 * @param {*} eventId  事件id
 * @param {string} [label='']  分类字段
 * @param {*} [data={}]   参数
 */

let userInfo = {};
getUserInfo().then((res) => {
  userInfo = res;
});

function report(eventId, label = '', data = {}) {
  // TODO
  // if (1) {
  //   return;
  // }
  try {
    if (typeof data == 'string') {
      throw TypeError('data必须是对象');
    }
    data = {
      language: sessionStorage.getItem('lang'),
      ...data
    };
    if (window.TDAPP) {
      if (userInfo.uid) {
        data = {
          ...data,
          user_id: userInfo.uid,
          device_id: userInfo.device_id,
          isPc: !navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          )
        };
      }
      window.TDAPP.onEvent(eventId, label, data);
      console.log('report：\n', eventId, label, data);
    } else {
      reportList.push({
        eventId,
        label,
        data
      });
      timingCheck();
    }
  } catch (error) {
    console.log(error);
  }
}

export default report;
